import Link from 'next/link';

import styles from './match-message.component.module.scss';

type Props = {
  companyName: string;
  matchHash: string;
};

export const MatchMessage = ({ companyName, matchHash }: Props) => (
  <div className={styles.matchMessageWrapper}>
    <Link className="jd-match" href={`/matches/${matchHash}`}>
      {companyName}とマッチしました！気軽にメッセージを送ってみましょう。
    </Link>
  </div>
);
